import React from 'react'
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import AppButton from './AppButton';
import AppOutlineButton from './AppOutlineButton';

const SaveBackButton = ({ onSave=()=>{}, onBack=null, showBackButton=true }) => {
  const { t } = useTranslation();
  const router = useHistory();
  return (
    <div className="sticky bottom-0 z-10 bg-white/70 backdrop-blur-md pt-5 flex gap-3 justify-end items-center flex-wrap">
   { showBackButton ? <AppOutlineButton
      variant="secondary"
      size="lg"
      onClick={() => (typeof onBack === "function" ? onBack() : router.goBack())}
    >
      {t("Back")}
    </AppOutlineButton> : null}
    <AppButton variant="primary" size="lg" onClick={onSave}>
      {t("Save")}
    </AppButton>
  </div>
  )
}

export default SaveBackButton